export default {
  ideate: require('../assets/images/ideate.svg'),
  design: require('../assets/images/design.svg'),
  build: require('../assets/images/setting.svg'),
  engineers: require('../assets/images/engineers.svg'),
  designers: require('../assets/images/designers.svg'),
  game: require('../assets/images/game.svg'),
  languages: require('../assets/images/languages.svg'),
  download: require('../assets/images/download.svg'),
  group: require('../assets/images/group.svg'),
  leftArrow: require('../assets/images/back-btn.svg'),
  rightArrow: require('../assets/images/right-arrow.svg'),
  close: require('../assets/images/close.png'),
  closeWhite: require('../assets/images/close-white.svg'),
  userInfo: require('../assets/images/user-info.png'),
  email: require('../assets/images/email-icon.png'),
  facebook: require('../assets/images/facebook-icon.png'),
  goodfirms: require('../assets/images/goodfirms-icon.png'),
  linkedin: require('../assets/images/linkedin-icon.png'),
  twitter: require('../assets/images/twitter-icon.png'),
  apple: require('../assets/images/apple-icon.svg'),
  blackberry: require('../assets/images/blackberry-icon.svg'),
  arrow: require('../assets/images/arrow.svg'),
  arrowHover: require('../assets/images/arrow-hover.svg'),
  hamburger: require('../assets/images/hamburger.svg'),

  // Ideate pieces
  ideateBottom: require('../assets/images/ideate/bottom.png'),
  ideateCenterBeam: require('../assets/images/ideate/center-beam.png'),
  ideateLeftBeam1: require('../assets/images/ideate/left-beam-1.png'),
  ideateLeftBeam2: require('../assets/images/ideate/left-beam-2.png'),
  bulb: require('../assets/images/ideate/bulb.png'),
  ideateRightBeam1: require('../assets/images/ideate/right-beam-1.png'),
  ideateRightBeam2: require('../assets/images/ideate/right-beam-2.png'),

  // Design
  designRuler: require('../assets/images/design/ruler.png'),
  designPencil: require('../assets/images/design/pencil.png'),

  // Build
  buildWindows: require('../assets/images/build/windows.png'),
  buildCogBig: require('../assets/images/build/cog-big.png'),
  buildCogSmall: require('../assets/images/build/cog-small.png')
}



// WEBPACK FOOTER //
// ./src/themes/Icon.js